import { getValidatedCustomView } from "c8-platform";
import Spec from "csi/core/Spec";
import { Context } from "csi/def/Context";
import csiPrefs from "csi/prefs";
import { getFilterAttributesUrlForType } from "csi/service/filterAttributeService";
import { getAttributeCardSpecsForType } from "csi/service/viewService";
import sessionConstants from "csi/sessionConstants";
import { cnl } from "csi/typings";
import declare from "dojo/_base/declare";
import { getSpecsFromCustomView } from "src/ProductPresentation/PPService";
import CustomViewAttributeTable from "../Attributes/CustomViewAttributeTable";
import BusinessObject from "../BusinessObject";

const FilterAttributesTable = declare(CustomViewAttributeTable, {

	/** @property {string} typeClass - class type for attributes */
	typeClass: null,

	/**
	 * Only allow adding filter attributes if user is a config editor
	 */
	accessActionAddAttributes(): boolean {
		return sessionConstants.configEditor;
	},

	/**
	 * Get attribute specs for filter attributes.
	 * If we don't have a filter attributes node, use card instead.
	 */
	async getFilterAttributeSpecs(type: string): Promise<Spec[]> {
		const filterAttributesUrl = this._composeKeyContainerUrl(type);
		const filterCustomView = await getValidatedCustomView(filterAttributesUrl);
		if (filterCustomView) {
			return getSpecsFromCustomView(filterCustomView);
		}

		const customViewUrl = csiPrefs.getAttributeCardUrlForType(type);
		const customView = await getValidatedCustomView(customViewUrl);
		const cardSpecs = getAttributeCardSpecsForType(type, customView);
		return cardSpecs.attributeSpecs;
	},

	/**
	 * @override
	 * get the specs async
	 */
	onBuildDeferreds(ctx: Context, dfds: Promise<Spec[]>[]) {
		const rc = BusinessObject.getAttributeClass(this.getViewNode());
		this.typeClass = rc.getType();
		const dfd = this.getFilterAttributeSpecs(this.typeClass);
		dfds.push(dfd);
		dfd.then((specs) => this.specs = specs);
	},

	/**
	 * Compose URL.
	 */
	_composeKeyContainerUrl(type: string): cnl {
		return getFilterAttributesUrlForType(type);
	},

	/**
	 * Get key container url.
	 */
	getKeyContainerUrl(): cnl {
		return this._composeKeyContainerUrl(this.typeClass);
	},
});

export = FilterAttributesTable;